import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Para qué tipo de profesional está recomendado?',
  a: 'El Masterpack está diseñado para nutricionistas, licenciados en nutrición, médicos con enfoque nutricional o funcional y profesionales de la salud que trabajan con pacientes y necesitan materiales clínicos listos, prolijos y reutilizables para acompañar sus tratamientos.'
}, {
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Recibís todos los archivos en formato PDF de alta resolución directamente en tu email, disponibles para descargar, imprimir o enviar por WhatsApp de forma inmediata.'
}, {
  q: '¿Puedo ponerle mi logo o firma profesional?',
  a: 'Sí. El material está diseñado para que puedas personalizarlo con tu identidad profesional. La licencia de uso incluida te permite utilizarlo con todos tus pacientes sin límites.'
}, {
  q: '¿Sirve para pacientes de cualquier país?',
  a: 'Absolutamente. Los protocolos aplican ciencia internacional y las listas incluyen alimentos universales adaptables a toda Latinoamérica y España.'
}, {
  q: '¿Qué pasa si mi paciente tiene una patología no incluida en los módulos?',
  a: 'Los protocolos base y las herramientas de monitoreo incluidas funcionan como soporte para cualquier abordaje nutricional, incluso fuera de las patologías específicas del pack.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 bg-white" data-id="element-28">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-29">
        <div className="text-center mb-10" data-id="element-30">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900 leading-tight" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-slate-50 rounded-2xl border border-slate-200 overflow-hidden" data-id="element-33">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center gap-4 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} id={`faq-trigger-${i}`} data-id="element-34">
                  <span className="font-bold text-slate-900 text-lg" data-id="element-35">
                    {faq.q}
                  </span>
                  <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-emerald-600 text-white' : 'bg-slate-200 text-slate-600'}`} data-id="element-36">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-37" /> : <Plus className="w-4 h-4" data-id="element-38" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-39">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} data-id="element-40">
                      <div className="px-6 pb-6 text-slate-600 leading-relaxed text-base" data-id="element-41">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}